import { Box, Button, Grid, makeStyles, OutlinedInput, Typography } from "@material-ui/core";
import React, { useCallback, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";

import Select from "../controls/Select.jsx";
import Checkbox from "../controls/Checkbox.jsx";
import Input from "../controls/Input.jsx";
import Form from "./Form.jsx";
import { useForm } from "./useForm.js";
import "./form.css";
import {deviceNames} from '../../app/DeviceSelector.tsx'

import { licences, expirationDates, speedParamateres, regionParameters } from "./serivces.js";
import "./form.css";
import { formValidation } from "./formValidation.js";

const useStyles = makeStyles((theme) => ({
  gridItem: {
    display: "flex",
    justifyContent: "center",
  },
  stackItem: {
    display: "flex",
    flexDirection: "column",
  },
  licenceData: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    flex: "1 0"
  },
  ButtonGenerate: {
    maxWidth: "12em",
    margin: "0.4em auto 3.5em auto",
    backgroundColor: "#0095da",
  },
}));

//initialValue of expirationDate is just 1 day in seconds
const initialValues = {
  id: 0,
  expirationDate: 2678400,
  maxSpeed: 60,
  serialNumber: "",
  licenceNumber: "",
  hasError: "",
  initialEvaluation: true,
  diagnosticStiffnessAndSpasticity: true,
  mvic: true,
  isometric: true,
  region: null
};


export default function FormLicenceLuna(props) {
  const { values, setValues, handleInputChange } = useForm(initialValues);
  const history = useHistory();

  useEffect(() => {
    if (props.deviceType == null) {
      history.push("/");
    }
  }, [props.deviceType, history]);


  //useRef
  const licenseNumberInput = useRef(null);
  const licenseNumberContainer = useRef(null);

  //useStyles
  const classes = useStyles();

  const generateLicenceKeyRequest = async(licenseData) => {
    try {
          // http for testing with local backend, https for production
      const backendProtocol = window.location.href.startsWith("https") ? "https" : "http";
      const backendUrl = `${backendProtocol}://license-generator-backend.internal.egzotech.com/api/generate-licence`;
      const response = await fetch(backendUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
        ...licenseData,
        // When region is 'international', send null to the backend
        region: licenseData.region === regionParameters[0].value ? null : licenseData.region,
        }),
      });

      const licenseKey = await response.json().then(data => data.licenceKey);

    if (formValidation(values.serialNumber)) {
      licenseNumberContainer.current.style.display = "flex";
      setValues({
        ...values,
        licenceNumber: licenseKey,
        hasError: "",
      });
    } else {
      setValues({
        ...values,
        licenceNumber: "",
        hasError: "Serial number contains error",
      });
    }

      if (!response.ok) {
        throw new Error("Failed to generate licence key");
      }

      const data = await response.json();
      return data.licenceKey;
    } catch (error) {
      console.log("Error:", error);
    }
  }

  const gridSpeed = useCallback(() => {
    return values.id === 1 ? (
      <Grid item xs={12} md={12} className={classes.gridItem}>
        <Select
          name="maxSpeed"
          label="Speed limit"
          value={values.maxSpeed}
          onChange={handleInputChange}
          options={speedParamateres}
        />
      </Grid>
    ) : values.id === 2 ? (
      <Grid item xs={12} md={12} className={classes.stackItem}>
        <Checkbox
          name="initialEvaluation"
          label="Initial evaluation"
          value={values.initialEvaluation}
          onChange={handleInputChange}
        />
        <Checkbox
          name="diagnosticStiffnessAndSpasticity"
          label="Diagnostic stiffness and spasticity"
          value={values.diagnosticStiffnessAndSpasticity}
          onChange={handleInputChange}
        />
        <Checkbox
          name="mvic"
          label="MVIC"
          value={values.mvic}
          onChange={handleInputChange}
        />
        <Checkbox
          name="isometric"
          label="Isometric"
          value={values.isometric}
          onChange={handleInputChange}
        />
      </Grid>
    ) : values.id === 3 ? (
      <Grid item xs={12} md={12} className={classes.gridItem}>
        <Select
          required
          hasError={values.hasError}
          name="region"
          label="Region"
          value={values.region}
          onChange={handleInputChange}
          options={regionParameters}
        />
      </Grid>
    ) : null
  }, [values, classes, handleInputChange]);

  const handleClickButton = (event) => {
    event.preventDefault();

    generateLicenceKeyRequest(
      values
    );

  };

  //Copy License Number to clipboard and display alert
  const handleCopyButton = useCallback(() => {
    if (!values.licenceNumber) return;

    const buttonContainer = licenseNumberContainer.current;
    const popup = document.createElement("div");
    navigator.clipboard
      .writeText(values.licenceNumber)
      .then((response) => {
        popup.classList.add("popup-copy-text-success");
        popup.textContent = "Copy success to clipboard";
        buttonContainer.appendChild(popup);
      })
      .catch((error) => {
        popup.classList.add("popup-copy-text-fail");
        popup.textContent = "Copy Failed";
        buttonContainer.appendChild(popup);
      });
  }, [values.licenceNumber]);

  //Selecting whole thext after one click
  const handleSelectAllText = useCallback(() => {
    licenseNumberInput.current.select();
  }, []);

  return (
    <Box style={{ maxWidth: 600, margin: "0 auto", marginTop: 32 }}>
      <Box mb={2} display="flex" flexDirection="column" alignItems="center">
        <Typography variant="h6" style={{ fontWeight: "bold" }}>
          Selected device: {deviceNames[props.deviceType]}
        </Typography>
        <Button
          variant="outlined"
          color="primary"
          style={{ marginTop: 12 }}
          onClick={() => history.push("/")}
        >
          Back to device selection
        </Button>
      </Box>
      <Form>

        <Grid container spacing={3}>
          <Grid item xs={12} md={6} className={classes.gridItem}>
            <Select
              name="id"
              label="Licence ID"
              value={values.id}
              onChange={handleInputChange}
              options={licences}
            />
          </Grid>
          <Grid item xs={12} md={6} className={classes.gridItem}>
            <Select
              name="expirationDate"
              label="Expiration date"
              value={values.expirationDate}
              onChange={handleInputChange}
              options={expirationDates}
            />
          </Grid>
          <Box className={classes.licenceData}>
            {gridSpeed()}
          </Box>
          <Grid item xs={12}>
            <div className="licence" placeholder="Licence Token">
              <Input
                label="Microsoft Serial Number"
                name="serialNumber"
                value={values.serialNumber}
                onChange={handleInputChange}
                hasError={values.hasError}
              />
              <Button
                variant="contained"
                color="primary"
                className={classes.ButtonGenerate}
                onClick={handleClickButton}
              >
                Generate Key
              </Button>

              <div
                ref={licenseNumberContainer}
                className="licence-button-container"
              >
                <OutlinedInput
                  readOnly
                  value={values.licenceNumber}
                  type="text"
                  onClick={handleSelectAllText}
                  inputRef={licenseNumberInput}
                  margin="dense"
                ></OutlinedInput>
                <Button onClick={handleCopyButton}>Copy License</Button>
              </div>
            </div>
          </Grid>
        </Grid>
      </Form>
    </Box>
  );
}
